/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Empty when the shop can be backfilled. Otherwise why not — no Shopify read was made.
 * @export
 * @enum {string}
 */

export enum PeriodBackfillShopIneligibility {
    SubscriptionNotActive = 'SUBSCRIPTION_NOT_ACTIVE',
    AvvNotAccepted = 'AVV_NOT_ACCEPTED',
    PendingDeletion = 'PENDING_DELETION',
    InvoicingNotConfigured = 'INVOICING_NOT_CONFIGURED'
}



